export default function CustomButton({ text, onClick }) {

    return (
        <button className="bg-teal-800 hover:bg-teal-900 text-white font-bold py-4 px-14 rounded-full text-3xl " onClick={onClick}>
            {text}
        </button>
    )
}